import { API_BASE } from "../../../../api_links";
import { uploadStaticData } from "../../../../uploadServices/uploadStaticData";
import { buildNotification } from "../../../notification/buildNotification";
import {
  signImageS3,
  uploadImageS3,
  deleteImageS3,
} from "../../../../uploadServices/imageUploader";

export const uploadCalendly = async (calendly) => {
  const dataUploadURL = `${API_BASE}:LiqXQBP3/calendly`;

  const { enable, url, title, icon, background } = calendly;

  const updateObj = {
    enable,
    url,
    title,
    icon,
    background,
  };

  icon.upload = "";

  console.log("Update data", updateObj);

  // Uploading icon
  console.log("Upload icon", icon.uploadable_file);
  if (icon.uploadable_file) {
    try {
      const signedRequestObject = await signImageS3(
        icon.uploadable_file,
        "calendly/Icons"
      );
      signedRequestObject.json().then(async (data) => {
        const { signedRequest, url } = data;
        if (!signedRequest || !url) return;
        try {
          const uploadResult = await uploadImageS3(
            icon.uploadable_file,
            signedRequest
          );
          console.log("upload s3 result", uploadResult, url);
          if (uploadResult.status === 200) {
            deleteImageS3(icon?.preview_file);
            updateObj.icon.preview_file = url;
            // Upload to xano
            uploadStaticData(true, dataUploadURL, updateObj, (result) => {
              console.log("Static Upload Result Calendly", result);
              if (result?.code) {
                buildNotification({
                  type: "error",
                  message: result?.message ?? "Error uploading Calendly icon",
                });
              } else {
                buildNotification({
                  type: "success",
                  message: "Calendly icon uploaded",
                });
              }
            });
          }
        } catch (error) {
          console.log(error);
        }
      });
    } catch (error) {
      console.log(error);
    }
  }

  // This callback would later be used for showing update notifications
  uploadStaticData(true, dataUploadURL, updateObj, (result) => {
    console.log("Static Upload Result Calendly", result);
    if (result?.code) {
      buildNotification({
        type: "error",
        message: result?.message ?? "Error uploading Calendly settings",
      });
    } else {
      buildNotification({
        type: "success",
        message: "Calendly Settings uploaded",
      });
    }
  });
};
